"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var theme_1 = require("utils/theme");
var layout_flex_1 = __importDefault(require("stories/layout-flex"));
exports.Wrapper = (0, styled_components_1.default)(layout_flex_1.default).attrs({
    direction: 'column',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  background-color: ", ";\n\n  & > * {\n    background-color: ", ";\n    margin-bottom: ", ";\n  }\n\n  & :last-child {\n    margin-bottom: 0;\n  }\n"], ["\n  width: 100%;\n  background-color: ", ";\n\n  & > * {\n    background-color: ", ";\n    margin-bottom: ", ";\n  }\n\n  & :last-child {\n    margin-bottom: 0;\n  }\n"])), function (props) {
    return props.visualizeSpacing ? theme_1.YELLOW000 : 'transparent';
}, function (props) {
    return props.visualizeSpacing ? theme_1.YELLOW100 : 'transparent';
}, function (props) { return "".concat(props.spacing, "px"); });
var templateObject_1;
